export default {
	WAITING: 'waiting',
	TRANSITIONING: 'transitioning',
	ANSWERED: 'answered',
	ENDED: 'ended',
}
